import { thunk } from 'easy-peasy';
import api from '~/services/api';

import { IThunkCrisisCallResolve } from '../types';

const onCrisisCallResolve: IThunkCrisisCallResolve = thunk(
  async (_actions, { clinicId, crisisCallId, tab, memo }) => {
    await api.crisis.crisisCallResolve(clinicId, crisisCallId, memo).then(r => r.data);

    return { tab, crisisCallId };
  },
);

export default onCrisisCallResolve;
